import {
  inventory_details_overall_v3,
  inventory_details_area_v3,
  inventory_details_cluster_v3,
  inventory_details_branch_v3,
} from "../../v3-services/reports/inventory_details_service";
import { actionTypes } from "../action_types";

const default_data = {
  branchCount: 0,
  totalPiecesDetails: {
    active: 0,
    expired: 0,
    expiredPercentage: 0,
  },
  totalPrincipalDetails: {
    active: 0,
    expired: 0,
    expiredPercentage: 0,
  },
  totalPieces: 0,
  totalPrincipal: 0,
  averagePrincipalPerPiece: 0,
};

const createInventoryDetailsAction = (fetchFunction, actionType) => (data) => (dispatch) => {
  return fetchFunction(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionType,
        payload: resp.data !== null ? resp.data : default_data,
      });
    }
    return Promise.resolve(resp);
  });
};

export const GetInventoryDetailsOverall_v3 = createInventoryDetailsAction(
  inventory_details_overall_v3,
  actionTypes.REPORTS_INVENTORY_DETAILS_GET_OVERALL
);

export const GetInventoryDetailsCluster_v3 = createInventoryDetailsAction(
  inventory_details_cluster_v3,
  actionTypes.REPORTS_INVENTORY_DETAILS_GET_CLUSTER
);

export const GetInventoryDetailsArea_v3 = createInventoryDetailsAction(
  inventory_details_area_v3,
  actionTypes.REPORTS_INVENTORY_DETAILS_TARGET_GET_AREA
);

export const GetInventoryDetailsBranch_v3 = createInventoryDetailsAction(
  inventory_details_branch_v3,
  actionTypes.REPORTS_INVENTORY_DETAILS_TARGET_GET_BRANCH
);
